"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let ContractEditor = class ContractEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "modal",
    };
    beforeCreate() {
    }
    getPayload(...args) {
        const [data] = args;
        return this.target ? _.pick(data, this.targetConfig[this.target].fieldsToSubmit) : data;
    }
    contract;
    onContract(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contract");
    }
    target;
    onTarget(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("target");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    defaultTitle;
    targetConfig;
    ux;
    dataMembers = ['formId', 'defaultTitle', 'targetConfig', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                defaultTitle: this.$fn.pgettext("Contract", "Edit General Information"),
                targetConfig: {
                    company: {
                        title: this.$fn.pgettext("Contract", "Edit company"),
                        fieldsToSubmit: ["id",
                            "revision_id",
                            "etag",
                            "company",
                        ],
                    },
                    counterparty: {
                        title: this.$fn.pgettext("Contract", "Edit counterparty"),
                        fieldsToSubmit: ["id",
                            "revision_id",
                            "etag",
                            "counterparty",
                        ],
                    },
                    invoicing: {
                        title: this.$fn.pgettext("Contract", "Edit invoicing information"),
                        fieldsToSubmit: ["id",
                            "revision_id",
                            "etag",
                            "invoicing",
                        ],
                    },
                    lifecycle: {
                        title: this.$fn.pgettext("Contract", "Edit lifecycle information"),
                        fieldsToSubmit: ["id",
                            "revision_id",
                            "etag",
                            "lifecycle",
                        ],
                    },
                    rental: {
                        title: this.$fn.pgettext("Contract", "Edit rental"),
                        fieldsToSubmit: ["id",
                            "revision_id",
                            "etag",
                            "rental",
                        ],
                    },
                    general: {
                        title: this.$fn.pgettext("Contract", "Edit general data"),
                        fieldsToSubmit: ["id",
                            "revision_id",
                            "etag",
                            "extras",
                            "revision_number",
                            "status",
                            "contract_type",
                            "contract_number",
                            "external_key",
                            "category_id",
                        ],
                    },
                },
                ux: null,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.target ? this.targetConfig[this.target].title : this.defaultTitle,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3730_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_3736_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_1040167445267876_crud_3734_getActionArgs($event) {
        return {
            objectType: "contract",
            op: "upsert",
            data: this.getPayload(this.contract),
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3730 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3730_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3729 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3730,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3729],
        });
        const act_2248226175642056_closeComponent_3732 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_3731 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_3732,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3731],
        });
        const act_1040167445267876_closeModal_3736 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_3736_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_3735 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_3736,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_crud_3734 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_3734_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_3735],
        });
        const evh_1040167445267876_submit_3733 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_3734,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_3733],
        });
        const act_1419464017721962_closeComponent_3738 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_3737 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_3738,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_3737],
        });
        return {
            act_7315092382398562_closeModal_3730,
            evh_7315092382398562_close_3729,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_3732,
            evh_2248226175642056_close_3731,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_3736,
            evh_1040167445267876_success_3735,
            act_1040167445267876_crud_3734,
            evh_1040167445267876_submit_3733,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_3738,
            evh_1419464017721962_clickPreventStop_3737,
            evh_1419464017721962_clickPreventStop,
            save: act_1040167445267876_crud_3734,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], ContractEditor.prototype, "contract", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contract'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractEditor.prototype, "onContract", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], ContractEditor.prototype, "target", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('target'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractEditor.prototype, "onTarget", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], ContractEditor.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractEditor.prototype, "onSize", null);
ContractEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], ContractEditor);
exports.default = ContractEditor;
vue_property_decorator_1.Vue.component("ContractEditor", ContractEditor);
